import {createStore} from 'vuex'
import {DEFAULT_LANGUAGE, messages} from "@/i18n";

export default createStore({
    state: {
        brandConfig: undefined,
        language: DEFAULT_LANGUAGE,
        msisdn: undefined
    },
    getters: {
        t(state) {
            return messages[state.language] ?? messages[DEFAULT_LANGUAGE];
        }
    },
    mutations: {
        setBrandConfig(state, brandConfig) {
            state.brandConfig = brandConfig
        },
        setLanguage(state, language) {
            state.language = language
        },
        setMsisdn(state, msisdn) {
            state.msisdn = msisdn
        }
    },
    actions: {},
    modules: {}
})
